<template>
  <label class="selectData">
    <select 
      :value="currentOption" 
      @change="handleOptionChange($event)">
      <option 
        v-for="option in options"
        :value="option.value" 
        key="option">
          {{ option.label }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  props: ["options", "currentOption"],
  emits: ["selectedOption"],
  setup(_, { emit }) {

    const handleOptionChange = (event) => {
      const selectedOption = event.target.value;
      emit('selectedOption', selectedOption);
    }

    return {
      handleOptionChange
    }

  }
}
</script>

<style scoped>
/*#region searchbox*/
.inputwrapper {
  border: 1px solid #79b2dc;
  display: flex;
  padding: 6px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: 250px;
  height: 45px;
  text-align: center;
  color: #777575;
}

.button_Search {
  font-size: 22px;
  padding-top: 4px;
  padding-right: 5px;
}

#searchstring {
  font-family: Montserrat;
  color: #cacaca;
  font-size: 15px;
  border: 0;
  background: transparent;
  width: 300px;
}

@media (max-width: 767px) {
  .inputwrapper {
    width: 100%;
  }
}

/*endregion searchbox*/
/*#region Filters*/
.selectData {
  margin-right: 10px;
  width: auto;
  position: relative;
}

.selectData select {
  width: 250px;
  margin-bottom: 0;
  border: 1px solid #79b2dc;
  height: 45px;
  font-family: Montserrat;
  color: #cacaca;
  font-size: 15px;
  background-image: none;
  padding-left: 33px;
}

label.selectData:before {
  content: "\f078";
  font-family: "FontAwesome";
  font-size: 16px;
  color: #1779ba;
  left: 10px;
  top: 7px;
  padding: 0 0 2px;
  position: absolute;
  pointer-events: none;
}

/*#endregion*/

@media (max-width: 767px) {

  .selectData select {
    width: 100%;
    margin-bottom: 10px;
    height: 38px;
    padding-left: 35px;
  }

  .inputwrapper {
    height: 35px;
  }

  .selectData {
    margin-right: 0px;
  }

  label.selectData:before {
    top: 5;
  }

  label.selectData:before {
    top: 5px;
  }
}
</style>